export default __webpack_public_path__ + "static/media/forward_10.3efc7a72.svg";